import storageService from "../../utils/StorageService";
import CONSTANT from "../../constants/Constant";
import authService from "../../services/AuthService";
import GLOBAL from "../../global";
import { prepareEnabledSubscribedFeatures } from "../../utils/Utils";
import { useContext } from "react";
import AppContext from "../../contexts/AppContext";

const useSignIn = () => {
    const {
        authenticate,
        storeUserInfo,
        storeUserInfoToLocalStorage
    } = useContext(AppContext);

    const handleSignInResponse = async (data) => {
        storageService.addItem(CONSTANT.JWT.TOKEN_KEY, data?.Token);
        storageService.addItem(CONSTANT.REFRESH_TOKEN.KEY_NAME, data?.RefreshToken);

        let userInfo = data || '{}';
        const isProvider = userInfo['RoleName'] === CONSTANT.ROLE.PROVIDER;
        // const isProviderLogin = storageService.getItem('providerLogin') === 'true';

        // if (!isProviderLogin && isProvider) {
        //     setErrorMessage(`You are not ${getUserIdentification().toLowerCase()}, please go to the provider view`);
        //     return;
        // }
        //
        // if (isProviderLogin && !isProvider) {
        //     setErrorMessage(`You are not provider, please go to the ${getUserIdentification().toLowerCase()} view`);
        //     return;
        // }

        const subscriptionFeatures = await getSubscriptionFeatures(userInfo, isProvider);
        userInfo.Permissions = prepareEnabledSubscribedFeatures(subscriptionFeatures);

        // if (isProvider) {
        //     window.location.href = `https://${GLOBAL.TENANT}.${CONSTANT.URLS.BASE_URL}/account/painemmalogin?patientId=${userInfo['ContactId']}&redirecturl=home`;
        //     return;
        // }
        //
        // if (userInfo.Permissions.IsNoFaultEnabled && !userInfo['IsIntakeSigned']) {
        //     window.location.href = `https://${GLOBAL.TENANT}.${CONSTANT.URLS.BASE_URL}/intake/info?patientId=${userInfo['ContactId']}&redirect=self&type=inclinic&invid=${GLOBAL.URL_PARAMS.INVITATION_ID}`;
        //     return;
        // }

        GLOBAL.USER_INFO = userInfo;
        authenticate(true);
        storeUserInfo(GLOBAL.USER_INFO);
        storeUserInfoToLocalStorage();

        return userInfo;
    }

    const getSubscriptionFeatures = async (userInfo, isProvider) => {
        let role = '';
        if (isProvider) {
            role = CONSTANT.ROLE.REFERRING_PROVIDER
        } else {
            role = CONSTANT.ROLE.PATIENT
        }
        const payload = { Role: role }
        const response = await authService.getSubscriptionFeature(payload);
        const { data, success, error } = response;

        if (!success) {
            console.error(error)
            return;
        }

        const subscriptionFeatures = data || '{}';
        GLOBAL.SUBSCRIPTION_FEATURES = subscriptionFeatures.Features;
        return subscriptionFeatures.Features;
    }

    // const handleStoreUserInfo = async (data) => {
    //     let userInfo = data || '{}';
    //     // const isProvider = userInfo['RoleName'] === CONSTANT.ROLE.PROVIDER;
    //     // const isProviderLogin = storageService.getItem('providerLogin') === 'true';
    //
    //     // if (!isProviderLogin && isProvider) {
    //     //     setErrorMessage(`You are not ${getUserIdentification().toLowerCase()}, please go to the provider view`);
    //     //     return;
    //     // }
    //     //
    //     // if (isProviderLogin && !isProvider) {
    //     //     setErrorMessage(`You are not provider, please go to the ${getUserIdentification().toLowerCase()} view`);
    //     //     return;
    //     // }
    //
    //     const subscriptionFeatures = await getSubscriptionFeatures(userInfo, isProvider);
    //     userInfo.Permissions = prepareEnabledSubscribedFeatures(subscriptionFeatures);
    //
    //     // if (isProvider) {
    //     //     window.location.href = `https://${GLOBAL.TENANT}.${CONSTANT.URLS.BASE_URL}/account/painemmalogin?patientId=${userInfo['ContactId']}&redirecturl=home`;
    //     //     return;
    //     // }
    //     //
    //     // if (userInfo.Permissions.IsNoFaultEnabled && !userInfo['IsIntakeSigned']) {
    //     //     window.location.href = `https://${GLOBAL.TENANT}.${CONSTANT.URLS.BASE_URL}/intake/info?patientId=${userInfo['ContactId']}&redirect=self&type=inclinic&invid=${GLOBAL.URL_PARAMS.INVITATION_ID}`;
    //     //     return;
    //     // }
    //
    //     GLOBAL.USER_INFO = userInfo;
    //     authenticate(true);
    //     storeUserInfo(GLOBAL.USER_INFO);
    //     storeUserInfoToLocalStorage();
    //
    //     return userInfo;
    // }

    return {
        handleSignInResponse,
        // handleStoreUserInfo
    }
}

export default useSignIn;
